<template>
	<article class="order-page">
		<modal title="操作提示" v-model="orderModal.Show" :mask-closable="false" @on-ok="postOrder()">
			<p>
				请于备注填写实际乘坐大巴车/船运的班次时间，客服会根据运力、路况等情况考虑略微提前接送时间，客服会于当天下午17：00分开始电话通知次日12：30分前的接送，次日10：30分电话通知12：30分后的接送，请保持电话畅通。
			</p>
		</modal>
		<section class="order_container">
			<div class="ticket_information_wrap initMp flex_wrap">
				<div class="ticket_information_righttext">
					<p class="order-info flex_wrap">
						<span class="info-head">
							<i class="iconfont icon-location2 red-text"></i>
							上车位置:
						</span>
						<span class="gray">{{ isGo ? startAddr : MarkName }}</span>
						<!--  					<span>{{bookingData.bookingStartAddr}}</span> -->
					</p>

					<p class="order-info flex_wrap">
						<span class="info-head">
							<i class="iconfont icon-location2 primaryColor-text"></i>
							下车地址:
						</span>
						<span class="gray">{{ isGo ? MarkName : startAddr }}</span>
						<!--  					<span>{{bookingData.bookingEndAddr}}</span> -->
					</p>

					<p class="order-info flex_wrap">
						<span class="info-head">
							<i class="iconfont icon-fuwu wx-primaryColor"></i>
							服务类型:
						</span>
						<span class="gray">{{ serviceType == 1 ? '随叫随到' : '预约用车' }}</span>
					</p>
					<p class="order-info flex_wrap">
						<span class="info-head">
							<i class="iconfont icon-location2 red-text"></i>
							预约时间:
						</span>
						<span class="gray">{{ bookingDate }}</span>
					</p>

					<div class="order-info">
						<span>
							<i class="iconfont icon-lianxiren"></i>
							联系人:
						</span>
						<!-- <input placeholder="请输入联系人姓名" type="text" :value="DefaultAddress.Contact" /> -->
						<span class="gray">{{ DefaultAddress.Contact }}</span>
					</div>

					<div class="order-info">
						<span>
							<i class="iconfont icon-dianhua"></i>
							联系电话:
						</span>
						<span class="gray">{{ DefaultAddress.Mobile }}</span>
					</div>

					<div class="order-info" @click="setLuggageNum">
						<span>
							<i class="iconfont icon-hanglixiang"></i>
							<em class="red-text">*</em>
							行李件数:
						</span>
						<span class="primaryColor-text">{{ luggageCount }}</span>
					</div>

					<div class="order-info" @click="setMemberCount">
						<span>
							<i class="iconfont icon-lvke"></i>
							<em class="red-text">*</em>
							乘车人数:
						</span>
						<span class="primaryColor-text">{{ memberCount }}</span>
					</div>

					<div class="order-info">
						<span>
							<i class="iconfont icon-beizhu"></i>
							*备注:
						</span>
						<input placeholder="请填写班车/船时间" type="text" v-model="userRemark" />
					</div>
				</div>
			</div>
		</section>

		<footer class="order_foot">
			<div class="terms flex_wrap a_i_center" @click="checkIsAgree">
				<i :class="isAgree ? 'iconfont icon-yigouxuan' : 'iconfont icon-weigouxuan'"></i>
				<p>
					<span>我已阅读并同意</span>
					<span class="primaryColor-text" @click.stop="showWarningTips">《旗妙出行约车须知》</span>
					<!-- <span class="primaryColor-text"><description-mask tipsType="appointTips"></description-mask></span> -->
				</p>
			</div>

			<div class="price_payment flex_wrap">
				<p class="price_text">
					总价 :
					<span class="red-text">&yen;{{ totalPrice }}</span>
					<!-- <i class="iconfont icon-xiala iconreversal"></i> -->
				</p>
				<button :class="!isAgree ? 'payment_btn' : 'payment_btn usable'" :disabled="!isAgree" @click.stop="orderModal.Show = true">提交订单</button>
			</div>
		</footer>

		<transition :name="transitionName" mode="out-in">
			<article v-show="showMask" class="mask_wrap" @click.self="showWarningTips">
				<!-- <section :class="['mask_container_wrap',showMask?'scale_up':'']"> -->
				<transition name="scale_up" mode="out-in">
					<section v-if="showMask" :class="['mask_container_wrap']">
						<div class="mask_article_wrap">
							<h3 class="article_title red_color">接送车服务须知</h3>
							<!-- <p class="p_title">一、注意事项</p> -->
							<p class="red-text">*当天12:30以前的班车接送，在乘车前一天下午17:00左右通知接送时间</p>
							<p class="red-text">*当天12:30以后的班车接送，在乘车当天早上10:00左右通知接送时间</p>

							<p class="p_title">一、预约接送服务需至少提前一天在[中山市旅游集散中心]公众号上提前购买。</p>
							<div style="text-align: center;">
								<img style="vertical-align: middle;text-align: center;" src="/../static/img/youtoqrcode.jpg" />
								<p class="text-center red-text">请先长按关注公众号以便接收订单消息推送</p>
							</div>
							<p class="p_title">
								二、请旅客收到接送时间后，提前到达接送地点，并保持电话畅通。若您所提供的电话号码长时间处于无人接听、忙音等状况而使我们不能及时联系到您，由此造成的损失，均由旅客本人负责。
							</p>
							<p class="p_title">
								三、由于旅客自身原因，未能准时到达预约地点的，且未提前联系客服0760-88880777说明原因的，逾时5分钟后视为自动放弃接送服务，接送费用照收，不作另外退还，非司机原因（如堵车、他人责任的交通事故等）造成旅客的延误或其他损失，我方不承担相应的责任。
							</p>
							<p class="p_title">四、服务车型为5座轿车，服务价格以我司移动端现行公示为准，旅客在我们的页面查看相关服务的价格。现行服务价格标准如下：</p>

							<div class="table xingli">
								<ul class="tr bg_th_orderinfo">
									<li class="th">起/止地</li>
									<li class="th">价格[{{ isGo ? '去程' : '返程' }}]</li>
									<!-- <li class="th">包车价格/车</li> -->
								</ul>
								<ul v-for="(item, key, index) in priceTable" :key="index" class="tr">
									<li class="td">{{ item.District }}</li>
									<li class="td">{{ item.singlePrice }}</li>
									<!-- <li class="td">{{ item.doublePrice }}元/车</li> -->
								</ul>
							</div>
							<p class="text-center red-text">2人8折、3人7折、4人6折。</p>
							<p class="text-center red-text">注：以上价格随时可能更新，具体以页面公示最新价格标准为准。</p>

							<p class="">A. 单人或2-3人购买接送服务，沿途拼车，同一订单同一地址视为1单接送，每车4位乘客为上限。</p>
							<p class="">B. 4人购买接送服务，同一订单同一地址视为包车接送.</p>
							<p class="p_title">五、行李件数：</p>
							<p class="">
								拼车每人可免费携带26寸以下行李1件(4人同一订单同一地址视为包车,行李总数不超4件)，超出行李（26寸以上按2件计算）按10元/件收取费用，若行李较多可在下单前电话咨询。
							</p>
							<p class="p_title">
								六、接送服务在未安排车辆和未通知接送时间前，旅客取消接送，不收取接送费；若已安排接送车辆并通知接送时的，由于旅客个人原因，需要取消接送服务的，视为自动放弃接送服务，不作另外退还。
							</p>

							<p class="p_title">
								七、旅客不得携带危险品或者其他法律、法规规定禁止或不适宜携带的物品搭乘车辆驾驶员的车辆，否则车辆驾驶员有权拒绝提供服务,并由旅客承担任何携带该等物品引起的后果和责任。
							</p>
							<p class="p_title">八、旅客不得在不乘坐车辆的情况下,委托驾驶员单独运送物品。</p>
							<p class="p_title">
								九、旅客不得在使用服务过程中进行违反平台规则的不文明的行为(包括吸烟、喝酒、吐痰、辱骂或殴打驾驶员) ,
								不得进行或要求车辆驾驶员进行违反相关交通规则或者其他法律法规的行为，因旅客违反禁止行为的原因导致有关部门行政处罚、人员受伤、发生交通事故、造成车辆损坏或其他损失的,旅客应向受损方进行赔偿
							</p>
							<p class="p_title">
								十、旅客应当具备完全民事行为能力(年满18周岁或年满16周岁、以自己的劳动收入为主要生活来源,且精神健康能完全辨认自己的行为) ,
								同时,旅客应当保证发布出行信息时是自愿的,且不存在意识不清楚、醉酒等情形。若旅客有意识不清楚、醉酒等情形的，陪同人员代为发布的出行需求信息视为旅客的行为;；在旅客醉酒或存在其他意识不清楚的情况下,应当由意识清楚的第三方陪同;；在旅客饮酒、醉酒或意识不清楚的情况下,给他人造成损失的,旅客本人应当就相应损失予以赔偿。
							</p>
						</div>
					</section>
				</transition>
			</article>
		</transition>
	</article>
</template>

<script>
import { mapState } from 'vuex';
//new
import businessApi from '@/request/businessApi';
import orderApi from '@/request/orderApi';
import paymentApi from '@/request/paymentApi';
import DescriptionMask from '@/components/child-components/DescriptionMask';
export default {
	name: 'order-page',
	components: {
		DescriptionMask
	},
	data() {
		return {
			showMask: false,
			transitionName: 'tanchu',
			orderData: null,
			// bookingData: {},
			// amounts: {},
			isShowTips: false,
			isAgree: false,
			estimatedAmount: 0,
			//new
			memberCount: 1,
			luggageCount: 0,
			userRemark: '',
			pickupPriceList: [],
			selectedPickupPriceModel: null,
			priceTable: [],
			orderModal: {
				Show: false
			},
			qrcodeUrl: '/static/img/youtoqrcode.jpg',
			limit: '',
			fromParams: '',

			isRental: false,
			Price: 0
		};
	},
	activated() {
		let that = this;
		this.orderData = null;
		// this.getRouterValue(); //new
		if (this.$route.params.limit && this.$route.params.limit.length > 0) {
			this.limit = this.$route.params.limit;
		}
		if (this.$route.params.from && this.$route.params.from.length > 0) {
			this.fromParams = this.$route.params.from;
		}
		if (this.$route.params.price) {
			this.Price = this.$route.params.price;
			console.log('this.Price=', this.Price);
		}
		if (this.$route.params.isrental) {
			this.isRental = this.$route.params.isrental;
			console.log('this.isRental=', this.isRental);
		}
		// this.getPickupPriceList(); // 2020-4-26
		wx.getLocation({
			type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
			success: res => {
				let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
				let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
				let speed = res.speed; // 速度，以米/每秒计
				let accuracy = res.accuracy; // 位置精度
				that.$store.commit('user/setLocation', longitude + ',' + latitude);
			}
		});
	},
	computed: mapState({
		startAddr: state => state.appoint.bookingStartAddr,
		endAddr: state => state.appoint.bookingEndAddr,
		//new
		MarkName: state => state.appoint.MarkName,
		isGo: state => state.appoint.isGo,
		bookingDate: state => state.appoint.bookingDate,
		serviceType: state => state.appoint.serviceType,
		businessName: state => state.appoint.businessSign,
		DefaultAddress: state => state.ticket.DefaultAddress,
		bookingStartPointLa: state => state.appoint.bookingStartPointLa,
		bookingStartPointLo: state => state.appoint.bookingStartPointLo,
		cityName: state => state.appoint.CityName,
		Location: state => state.user.Location,
		totalPrice() {
			var price = 0;
			// if (this.selectedPickupPriceModel) {
			// 	let basePrice = 0;
			// 	if (this.isGo) {
			// 		basePrice = this.memberCount * (this.selectedPickupPriceModel.Price + this.selectedPickupPriceModel.OTPrice);
			// 	} else {
			// 		basePrice = this.memberCount * (this.selectedPickupPriceModel.BackPrice + this.selectedPickupPriceModel.BackOTPrice);
			// 	}
			// 	switch (this.memberCount) {
			// 		case 1:
			// 			price += basePrice;
			// 			break;
			// 		case 2:
			// 			price += Math.round(basePrice * 0.8);
			// 			break;
			// 		case 3:
			// 			price += Math.round(basePrice * 0.7);
			// 			break;
			// 		case 4:
			// 			if (this.selectedPickupPriceModel.Price == 15) {
			// 				price = 25;
			// 			} else if (this.selectedPickupPriceModel.Price == 20) {
			// 				price = 40;
			// 			} else if (this.selectedPickupPriceModel.Price == 30) {
			// 				price = 50;
			// 			} else if (this.selectedPickupPriceModel.Price == 40) {
			// 				price = 70;
			// 			} else if (this.selectedPickupPriceModel.Price == 75) {
			// 				price = 130;
			// 			} else if (this.selectedPickupPriceModel.Price == 95) {
			// 				price = 150;
			// 			}
			// 			break;
			// 	}
			// 	if (this.luggageCount > this.memberCount) {
			// 		price += 10 * (this.luggageCount - this.memberCount);
			// 	}
			// 	return price;
			// }
			// if (!this.isRental) {
			// 	if (this.Price != 0) {
			// 		let basePrice = 0;
			// 		if (this.isGo) {
			// 			basePrice = this.memberCount * this.Price;
			// 		} else {
			// 			basePrice = this.memberCount * this.Price;
			// 		}
			// 		switch (this.memberCount) {
			// 			case 1:
			// 				price += basePrice;
			// 				break;
			// 			case 2:
			// 				price += Math.round(basePrice * 0.8);
			// 				break;
			// 			case 3:
			// 				price += Math.round(basePrice * 0.7);
			// 				break;
			// 			case 4:
			// 				price += Math.round(basePrice * 0.6);
			// 				break;
			// 		}
			// 		if (this.luggageCount > this.memberCount) {
			// 			price += 10 * (this.luggageCount - this.memberCount);
			// 		}
			// 		return price;
			// 	}
			// } else {
			// 	if (this.luggageCount > this.memberCount) {
			// 		price += 10 * (this.luggageCount - this.memberCount);
			// 	}
			// 	price += parseInt(this.Price);
			// 	return price;
			// }
			return this.Price;
		}
	}),
	methods: {
		setLuggageNum() {
			let luggageNum = [];
			if (!luggageNum.length) {
				for (let i = 0; i <= 4; i++) {
					var luggage_item = {};
					luggage_item.label = ('' + i).length === 1 ? '' + i : '' + i;
					// luggage_item.label = ('' + i).length === 1 ? '0' + i : '' + i;
					luggage_item.value = i;
					luggageNum.push(luggage_item);
				}
			}
			this.$weui.picker(luggageNum, {
				onConfirm: result => {
					this.luggageCount = parseInt(result[0].label);
				}
			});
		},
		setMemberCount() {
			let memberNum = [];
			if (!memberNum.length) {
				for (let i = 1; i <= 4; i++) {
					var member_item = {};
					member_item.label = ('' + i).length === 1 ? '' + i : '' + i;
					// luggage_item.label = ('' + i).length === 1 ? '0' + i : '' + i;
					member_item.value = i;
					memberNum.push(member_item);
				}
			}
			this.$weui.picker(memberNum, {
				onConfirm: result => {
					this.memberCount = parseInt(result[0].label);
				}
			});
		},
		showWarningTips() {
			this.showMask = !this.showMask;
		},

		getPickupPriceList() {
			this.$Spin.show();
			businessApi.getBusinessPickupPriceList(this.businessName, this.MarkName).then(sucRes => {
				this.$Spin.hide();
				if (sucRes.success && sucRes.data.length > 0) {
					this.pickupPriceList = sucRes.data;
					this.makePriceTable();
					this.pickupPriceList.forEach(item => {
						if (item.District == this.DefaultAddress.District) {
							if (item.Status) {
								this.selectedPickupPriceModel = item;
							} else {
								this.$Message.warning('当前区域不支持接送！');
								this.$router.go(-1);
							}
						}
					});
				} else {
					this.$Message.warning('没有该点的接送报价！');
					this.$router.go(-1);
				}
			});
		},
		// 生成价格表
		makePriceTable() {
			let tmpPriceArr = [];
			this.priceTable = [];
			for (let i = 0; i < this.pickupPriceList.length; i++) {
				if (this.pickupPriceList[i].Status) {
					if (this.isGo) {
						let tmpPrice = this.pickupPriceList[i].Price;
						if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
					} else {
						let tmpPrice = this.pickupPriceList[i].BackPrice;
						if (tmpPriceArr.indexOf(tmpPrice) == -1) tmpPriceArr.push(tmpPrice);
					}
				}
			} // 生成价格数组
			tmpPriceArr.sort((val1, val2) => {
				return val1 - val2;
			});
			for (let i = 0; i < tmpPriceArr.length; i++) {
				let tmpDistrictStr = '';
				for (let j = 0; j < this.pickupPriceList.length; j++) {
					if (this.isGo) {
						if (this.pickupPriceList[j].Price == tmpPriceArr[i]) tmpDistrictStr += this.pickupPriceList[j].District + '、';
					} else {
						if (this.pickupPriceList[j].BackPrice == tmpPriceArr[i]) tmpDistrictStr += this.pickupPriceList[j].District + '、';
					}
				}
				tmpDistrictStr = tmpDistrictStr.substring(0, tmpDistrictStr.length - 1);
				let priceComputedDescription = '';
				priceComputedDescription += Math.round(tmpPriceArr[i]) + '/1人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 2 * 0.8) + '/2人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 3 * 0.7) + '/3人 ';
				priceComputedDescription += Math.round(tmpPriceArr[i] * 4 * 0.6) + '/4人';
				var tmpObj = { District: tmpDistrictStr, singlePrice: tmpPriceArr[i], doublePrice: tmpPriceArr[i] * 2, priceComputedDescription: priceComputedDescription };
				this.priceTable.push(tmpObj);
			}
		},
		changeMemberCount(val) {
			this.memberCount = this.memberCount + val;
		},
		changeLuggageCount(val) {
			this.luggageCount = this.luggageCount + val;
		},
		postOrder() {
			if (this.orderData != null && this.orderData.ID > 0) {
				this.payRequest();
				return;
			}
			if (this.totalPrice <= 0 || this.Price == 0) {
				this.$Message.warning('价格有问题！');
				this.$router.go(-1);
			}
			if (this.mobile == '' || this.contact == '') {
				this.$Message.warning('请输入联系电话！以便司机电话确认。');
				return;
			}
			if (this.isGo && this.userRemark == '') {
				alert('去程旅客请于备注输入乘坐班车/船时间、行李大小，以便客服安排。');
				return;
			}
			this.$Spin.show();
			orderApi
				.createBusinessAppointOrderNew(
					this.$store.state.user.OpenId,
					this.DefaultAddress.Contact,
					this.businessName,
					this.MarkName,
					this.memberCount,
					this.luggageCount,
					this.bookingDate,
					this.serviceType,
					this.DefaultAddress.Mobile,
					this.DefaultAddress.District,
					this.DefaultAddress.Address,
					this.bookingStartPointLa,
					this.bookingStartPointLo,
					this.cityName,
					this.Price,
					this.userRemark,
					this.isGo ? 1 : 0,
					this.limit,
					this.isRental,
					this.Location,
					this.fromParams
				)
				.then(sucRes => {
					if (sucRes.success) {
						this.$Message.success(sucRes.message);
						this.orderData = sucRes.data;
						this.payRequest();
					} else {
						this.$Message.error(sucRes.message);
					}
					this.$Spin.hide();
				});
		},
		payRequest() {
			var that = this;
			this.$Spin.show();
			wx.miniProgram.getEnv(function(res) {
				if (res.miniprogram) {
					// true代表在小程序里
					that.$Spin.hide();
					var url = `../webpayprocess/webpayprocess?ordertype=2&id=${that.orderData.ID}&businessid=2`;
					wx.miniProgram.navigateTo({
						url: url
					});
				} else {
					//false代表在公众号里
					paymentApi.getWeChatPayParams(that.$store.state.user.OpenId, that.orderData.ID, 2, 2).then(sucRes => {
						if (sucRes.success) {
							wx.chooseWXPay({
								timestamp: sucRes.data.timeStamp,
								nonceStr: sucRes.data.nonceStr,
								package: sucRes.data.package,
								signType: sucRes.data.signType,
								paySign: sucRes.data.paySign,
								success: res => {
									that.$Message.success('支付成功！');
									that.$router.replace({
										name: 'MainIndexPage',
										params: {
											page: 'myorder'
										}
									});
									// window.location.href = '//www.callmefix.net/wechat/orderlst/';
								},
								fail: fail => {
									that.$Message.warning('支付失败！');
									that.$router.replace({
										name: 'MainIndexPage',
										params: {
											page: 'myorder'
										}
									});
								}
							});
						} else {
							that.$Message.error(sucRes.message);
						}
						that.$Spin.hide();
					});
				}
			});
		},
		checkIsAgree() {
			this.isAgree = !this.isAgree;
		},
		showBuyTicketTips() {
			this.isShowTips = !this.isShowTips;
		}
	}
};
</script>

<style scoped lang="less">
@import '../style/public';

.order-page {
	.order_container {
		flex: 1;
		overflow: auto;
	}
}
.order_foot {
	/*position: fixed;
  	bottom: 0;*/
}
.order-info {
	& .iconfont {
		margin-right: 5px;
	}
}
.terms {
	background-color: rgba(0, 0, 0, 0.8);
	color: #fff;
	font-size: 0.35rem;
	line-height: 1.2rem;
	.flex_wrap(initial);
}
.terms > p {
	font-size: 0.4rem;
}
.terms > .iconfont {
	width: 15%;
	align-self: stretch;
	text-align: center;
	font-size: 0.5rem;
	padding-top: 2px;
	margin: 0;
}
.terms > .iconfont.icon-yigouxuan {
	color: #69cbff;
}

/*计价明细*/
.price_detail {
	height: 12vh;
	transition: all 0.3s;
	overflow: auto;
}
.price_detail_title > h6 {
	background-color: #E77618;
	color: #ffffff;
	text-align: center;
	line-height: 4vh;
	font-size: 0.4rem;
	text-indent: 2px;
	letter-spacing: 2px;
}
.bus_ticket_detail > span {
	padding: 0 3%;
	font-size: 0.35rem;
	color: #333;
	line-height: 4vh;
}
/*支付*/

.price_payment {
	border-top: 1px solid #888;
	.flex_wrap(initial);
}
.price_payment > .price_text,
.price_payment > .payment_btn {
	flex: 0 0 50%;
}
.price_text,
.payment_btn {
	line-height: 1.2rem;
	text-align: center;
	font-size: 0.45rem;
}
.price_text > span {
	font-weight: 600;
	transition: all 0.3s;
}
.payment_btn {
	border: none;
	color: #888;
	background-color: #ddd;
}
.usable {
	background-color: #e22222;
	color: #fff;
}
.payment_btn.usable:active {
	background-color: #ba1b1b;
	color: #eee;
}
/*add-order-page---------------1108*/
.initMp.ticket_information_wrap {
	margin: 0;
	border-width: 0 0 2px 0;
}
.order-info {
	.blockPadding(0.2rem, 0.4rem);
	border-bottom: 1px solid #888;
	line-height: 1rem !important;
	& .icon-lianxiren {
		font-size: 0.46rem;
	}
}
.order-info > input {
	border: none;
	background-color: transparent;
	font-size: 0.38rem;
}
.info-head {
	flex: 0 0 25%;
}
.ticket_information_righttext {
	padding: 0;
}
/*add----------------1108*/

.text-center {
	text-align: center;
}

.scale_up {
	transform: scale(1);
}
</style>



// WEBPACK FOOTER //
// src/components/NewOrderPage.vue